import { useCounters } from "@/components/new-resolver/useFindListings";
import { usePath } from "@/contexts/path/path";
import { useAppState } from "@/contexts/app/app.provider";
import { useEffect, useMemo, useState } from "react";
import css from "@/components/new-resolver/.module.scss";
import AppLink from "@/components/new-resolver/app.ink";
import CounterButton, {
  CountersButtonsHolder,
} from "@/components/new-resolver/CountersButtons";
import { useQuery } from "@apollo/client";
import { GET_ALL_CITIES } from "@/graphql/queries/regions";

function CitiesList({
  numberOfCities = 4,
  category,
  isMobile,
  trackingEvent,
} = {}) {
  const { loading: citiesLoading, data: { Web: citiesRes } = {} } = useQuery(
    GET_ALL_CITIES,
    {
      variables: {
        ...(category ? { category: category.id } : {}),
      },
    },
  );
  const { updateContext } = usePath();

  const cities = citiesRes?.cities || [];
  const firstCities = useMemo(() => cities.slice(0, numberOfCities), [cities]);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  if (citiesLoading) {
    return <CountersButtonsHolder isMobile={isMobile} />;
  }

  return (
    !!cities.length && (
      <div className={css.counter}>
        <div>
          {firstCities.map((ci) => (
            <AppLink
              className={css.btn}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                scrollToTop();
                trackingEvent?.();
                return updateContext({
                  page: 0,
                  polygon: undefined,
                  listing: null,
                  city: { ...ci, id: ci.city_id },
                  category: category,
                });
              }}
              key={ci.path}
              path={ci.path}
            >
              {ci.title}&nbsp;<span>({ci.count})</span>
            </AppLink>
          ))}
        </div>
      </div>
    )
  );
}

export default CitiesList;
